function getConnectionType() {
  const { performance: p } = window;
  return p && p.navigation && "type" in p.navigation ? p.navigation.type : 255;
}

function isNormalNavigation() {
  return getConnectionType() === 0;
}
function isReloadNavigation() {
  return getConnectionType() === 1;
}
function isForwardBackwardNavigation() {
  return getConnectionType() === 2;
}

var index = /*         */Object.freeze({
  __proto__: null,
  getConnectionType: getConnectionType,
  isForwardBackwardNavigation: isForwardBackwardNavigation,
  isNormalNavigation: isNormalNavigation,
  isReloadNavigation: isReloadNavigation
});

export { isNormalNavigation as a, isReloadNavigation as b, isForwardBackwardNavigation as c, getConnectionType as g, index as i };
/*                                 */
